// extracted by mini-css-extract-plugin
export default {"container":"a1-z"};